interface Props {
    label: string;
    className?: string;
    fontSize?: string;
    fontWeight?: string;
    isRequired?: boolean;
    requiredText?: string;
    textColor?: string;
    customStyle?: string;
}

export default function Label({ customStyle = '', textColor = 'text-gray-700', label, className = '', fontSize = 'text-xs', fontWeight = 'font-medium', isRequired, requiredText = ' *' }: Props) {
    return (
        <label className={`block ${customStyle} ${className} ${fontSize} ${fontWeight} ${textColor} truncate`}>
            <span>{label}</span>
            {isRequired && <span className="text-red-500">{requiredText}</span>}
        </label>
    );
}